import { motion, useAnimationControls } from "framer-motion";
import React, { useEffect } from "react";
import { useInView } from "react-intersection-observer";

const animations = {
  "slide-left": {
    animate: {
      x: 0,
      delay: 1,
      transition: { type: "spring", mass: 0.5, bounce: 0.25, stiffness: 100 },
    },
    initial: { x: "-100vw" },
  },
  "slide-down": {
    animate: {
      y: 0,
      delay: .8,
      transition: { type: "spring", mass: 0.5, bounce: 0.25, stiffness: 100 },
    },
    initial: { y: "-100vh" },
  },
  "zoom-in": {
    initial: { scale: 0.5 },
    animate: {
      delay: 1,
      scale: 1,
      transition: {type:"", duration: 1 },
    },
  },
};

export default function Animate({ children, type = "slide-left" }) {
  const { ref, inView } = useInView({
    threshold: 0.3,
  });

  const controls = useAnimationControls();

  useEffect(() => {
    if (inView) {
      controls.start(animations[type].animate);
    } 
  }, [controls, inView, type]);

  return (
    <div ref={ref}>
      <motion.div animate={controls} initial={animations[type].initial}>
        {children}
      </motion.div>
    </div>
  );
}
